<template>
  <div id="indicator">
      <div id="arrow" v-if="grow!=null">
        <svg viewBox="25 -25 25 75">
          <g>
            <path
              :transform="grow?'scale(1,-1) translate(0,-40)':''"
              d="m 34.775,0.4305 v 26.577 H 27.08 L 38.54,49.5695 50,27.0075 H 42.305 V 0.4305 Z"
              style="fill-rule:evenodd;paint-order:stroke fill markers"
              :style="{fill: grade_growth?'#C9D713':'#DD3434'}"/>
          </g>
        </svg>
      </div>
      <div id="wrapper">
        <div id="number" :class="'place'+orders[0]" :style="numberNewLine?'width:100%':'width:50%'">{{ value }}</div>
        <div id="image" :class="'place'+orders[1]" v-if="svg">
          <svg
            viewBox="0 0 50 50">
            <g v-html="svg"></g>
          </svg>
        </div>
        <div id="title" class="place3" :style="!numberNewLine?'width:100%':'width:50%'">{{ title }}</div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'load-screen',
  props: ['title', 'value', 'svg', 'grow', 'grade_growth'],
  mounted () {
    this.orders.sort(() => Math.random() - 0.5)
    if (this.orders[0] === 1) this.numberNewLine = (Math.random() >= 0.5)
  },
  data () {
    return {
      orders: [1, 2],
      numberNewLine: false
    }
  }
}
</script>

<style scoped lang="scss">
@import '../assets/scss/variables.scss';
#indicator{
    margin:0.5em 2.3em;
}
#arrow{
  width: 2.5em;
  float: left;
}
#wrapper {
  display: inline-flex;
    justify-content: space-around;
    flex-wrap: wrap;
    max-width: 15em;
}
#number{
  color: $k-turq;
  font-family: MuseoSans-900;
  margin-bottom: -.2em;
  font-size: 5.5em;
  z-index: 1;
  display: inline-block;
}
#title{
  color: $k-lime;
  font-family: MuseoSans-700;
  font-size: 1.2em;
  z-index: 1;
  hyphens: auto;
  word-break: break-word;
  text-transform: uppercase;
  display: inline-block;
}
#image{
  max-width: 50%;
  width: 6em;
  height: 6em;
  z-index: 0;
  display: inline-block;
}

.place1{
    order: 1;
}
.place2{
    order: 2;
}
.place3{
    order: 3;
}
</style>



// WEBPACK FOOTER //
// src/components/Indicator.vue